import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(2),
  },
  rootCard: {
    width: '100%',
  },
}))

export default styles
